var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalConversionsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 9.84375C10.6354 9.84375 11.8125 8.6666 11.8125 7.21875C11.8125 5.7709 10.6354 4.59375 9.1875 4.59375V6.5625L5.90625 3.28125L9.1875 0V1.96875C12.0873 1.96875 14.4375 4.31895 14.4375 7.21875C14.4375 10.1186 12.0873 12.4688 9.1875 12.4688V9.84375ZM5.25 1.96875C2.3502 1.96875 0 4.31895 0 7.21875C0 10.1186 2.3502 12.4688 5.25 12.4688V14.4375L8.53125 11.1562L5.25 7.875V9.84375C3.80215 9.84375 2.625 8.6666 2.625 7.21875C2.625 5.7709 3.80215 4.59375 5.25 4.59375V1.96875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalConversionsIcon);
export default __webpack_public_path__ + "static/media/total-conversions-icon.c912e802acdfef37b310c247a97e00a1.svg";
export { ForwardRef as ReactComponent };